import { AppError } from '@/utility/errorClasses';

export const getUserSession = async (): Promise<UserSession | null> => {
  return await fetch('/api/v1/users/current')
    .then((response) => {
      if (!response.ok) return null;
      return response.json();
    })
    .catch(() => null);
};

export const getIdentity = async (): Promise<Identity | null> => {
  return await fetch('/api/v1/identities/current')
    .then((response) => {
      if (!response.ok) return null;
      return response.json();
    })
    .catch(() => null);
};

export const logout = async (): Promise<boolean> => {
  return fetch('/api/v1/sessions/current', {
    method: 'DELETE',
  }).then((response) => {
    if (!response.ok) {
      throw new AppError(`Logout failed with status ${response.status}`, response.status);
    }
    return true;
  });
};
